<template>
  <div>
    <list
      row-key="OfflinePayId"
      ref="list"
      unit="线下支付信息"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <customer  @restaurants='setSupplier' :state='params.CustomerName'/>
        </el-form-item>
        <el-form-item label="支付日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.PayTimeStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.PayTimeEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="CustomerName" label="客户名称" min-width="170px" show-overflow-tooltip />
          <el-table-column prop="Type" label="来源" min-width="80px">
          <template slot-scope="{row}">
            <span v-if="row.Type==0">小程序</span>
            <span v-else>后台</span>
          </template>
        </el-table-column>
        <el-table-column prop="UseTo" label="类型" min-width="80px">
          <template slot-scope="{row}">
            <span v-if="row.UseTo==0">储值卡充值</span>
            <span v-else>还款</span>
          </template>
        </el-table-column>
        <el-table-column prop="PayNo" label="流水号" min-width="180px" />
        <el-table-column prop="PayAmount" label="金额" min-width="100px" />
        <el-table-column prop="PayTime" label="支付时间" min-width="100px">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.PayTime)}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="图片" min-width="100px">
          <template slot-scope="{row}">
            <el-image
              style="width: 50px"
              :src="'/api'+row.PicUrl"
              :preview-src-list="['/api'+row.PicUrl]"
            ></el-image>
          </template>
        </el-table-column> -->
        <el-table-column prop="Status" label="付款状态" align="center" width="100px">
          <template slot-scope="{row}">
            <el-tag type="primary" v-if="row.Status==0">待审核</el-tag>
            <el-tag type="success" v-if="row.Status==1">审核通过</el-tag>
            <el-tag type="danger" v-if="row.Status==2">审核不通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="200px" show-overflow-tooltip />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list,customer },
  data() {
    return {
      api: require("@/api/sy/offlinePay").default,
      params: {
        CustomerName: "",
        PayTimeStart:null,
        PayTimeEnd:null
      },
    };
  },
  methods: {
    setSupplier(data) {
      
      this.params.CustomerName = data.TradeUnitName;
    },
  },
};
</script>